import { API_ROOT } from '../../config/config'
import { doGet, doPostFiles, doPost, doDownload, doPut } from './utils'

// const API_ROOT = 'http://localhost:9005/api'

export const getCheckNotice = (projectVersionId, noticeId) => {
  // /api/progress/notice/get/{projectVersionId}
  const url = `${API_ROOT}/progress/notice/get/${projectVersionId}?noticeId=${noticeId || ''}`
  return doGet(url)
}

export const saveCheckNotice = (request, projectVersionId) => {
  const url = `${API_ROOT}/progress/notice/save/${projectVersionId}`
  return doPostFiles(url, request)
}

export const approvedCheckNotice = (projectVersionId, request) => {
  // /api/progress/notice/request-approve/{projectVersionId}/{noticeId}
  const url = `${API_ROOT}/progress/notice/approved/${projectVersionId}`
  return doPut(url, request)
}

//Download file
export const getSuppendedNoticeFile = (fileId) => {
  const url = `${API_ROOT}/progress/notice/attachments/download/${fileId}`
  return doDownload(url)
}

//Generate file
export const downloadCallBookNotice = (projectSuspendedNoticeId) => {
  // /api/files/{projectSuspendedNoticeId}/suspended/notice/letter
  const url = `${API_ROOT}/files/${projectSuspendedNoticeId}/suspended/notice/letter`
  return doDownload(url)
}
